import './index.less';

import classNames from 'classnames';
import { forwardRef, Ref, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const FeedbackDialog = (
  { onEnsureCb }: { onEnsureCb?: () => void },
  ref: Ref<any>,
) => {
  const [show, setShow] = useState(false);
  const { t: $t, i18n } = useTranslation('user-feedback');

  const preventScroll = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
  }));

  const handlerOk = () => {
    setShow(false);
    onEnsureCb?.();
  };

  return show ? (
    <div className="feedback-mask" onWheel={preventScroll}>
      <div
        className={classNames('feedback-dialog', {
          'feedback-dialog-ja-jp': i18n.language === 'ja-JP',
        })}
      >
        <img src="/images/user-feedback/success.svg" alt="" />
        <p className="feedback-dialog-title">{$t('feedbackInfoThank')}</p>
        <span className="feedback-dialog-btn" onClick={handlerOk}>
          {$t('feedbackInfoConfirm')}
        </span>
      </div>
    </div>
  ) : null;
};

export default forwardRef(FeedbackDialog);
